export default {
  svgPath: `
    <path d="M5.086 10l3.207 3.207a1 1 0 001.414 0L14.914 8 13.5 6.586l-4.5 4.5-2.5-2.5L5.086 10z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zm-2 0a8 8 0 11-16 0 8 8 0 0116 0z"/>
  `,
  title: 'Check Circle',
};

